<div class="max-w-2xl mx-auto p-4">

  <h2 class="text-xl font-semibold mb-4">Tracking Details</h2>

  <div class="flex justify-between mb-8">
    <div class="text-center" [class.text-blue-600]="currentIndex >= 0">
      <div class="w-10 h-10 rounded-full border flex items-center justify-center mb-1"
           [class.bg-blue-600]="currentIndex >= 0" [class.text-white]="currentIndex >= 0">🛠</div>
      Processing
    </div>

    <div class="text-center" [class.text-blue-600]="currentIndex >= 1">
      <div class="w-10 h-10 rounded-full border flex items-center justify-center mb-1"
           [class.bg-blue-600]="currentIndex >= 1" [class.text-white]="currentIndex >= 1">📦</div>
      Packed
    </div>

    <div class="text-center" [class.text-blue-600]="currentIndex >= 2">
      <div class="w-10 h-10 rounded-full border flex items-center justify-center mb-1"
           [class.bg-blue-600]="currentIndex >= 2" [class.text-white]="currentIndex >= 2">🚚</div>
      Shipped
    </div>

    <div class="text-center" [class.text-blue-600]="currentIndex >= 3">
      <div class="w-10 h-10 rounded-full border flex items-center justify-center mb-1"
           [class.bg-blue-600]="currentIndex >= 3" [class.text-white]="currentIndex >= 3">✔</div>
      Delivered
    </div>
  </div>

  <div *ngFor="let h of history" class="mb-3">
    <div class="text-sm">{{ h.Date }} - <strong>{{ h.Status }}</strong></div>
    <div class="text-gray-600 text-xs">{{ h.Message }} [{{ h.Location }}]</div>
  </div>

</div>
